export const stageGrotesk = {
  variable: '--font-stage-grotesk',
};
